export default __webpack_public_path__ + "static/media/token.a10f561f.svg";